<template>
	<v-autocomplete
		:items="items"
		:item-text="text"
		:item-value="value"
		outlined
		filled
		dense
		clearable
		label="Seleccione un usuario"
		no-data-text="No hay usuarios"
		@change="e => onChange(e)"
	></v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	props: {
		setUser: {
			type: Function,
			required: true,
		},
		cleaning: {
			type: Function,
			required: true,
		},
		role: { type: String, default: 'admin' },
	},
	computed: {
		items() {
			return this.users.filter(item => item.role === this.role);
		},
		...mapGetters({
			users: 'User/users',
		}),
	},
	methods: {
		async onChange(user) {
			this.cleaning();
			this.setUser(user);
			if (user) {
				if (user.role === 'admin') this.getAudits({ id: user._id });
			}
		},
		text(text) {
			return `${text.name} - ${text.email}`;
		},
		value(text) {
			return text;
		},
		...mapActions({
			fetchUsers: 'User/fetchUsers',
			getAudits: 'Audit/getAudits',
		}),
	},
};
</script>
